module.exports = __webpack_public_path__ + "static/img/user.fa5aafa8.png";